// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-table-wrapper[data-v-b6a60322]{display:flex;padding-left:0;padding-right:0;padding-top:.75rem;padding-bottom:.75rem}", ""]);
// Exports
module.exports = exports;
